import sharedGlobal from '../sharedglobals'

export default function request(options) {
    if (options.params) {
        if (options.url.indexOf('?') >= 0) {
            options.url += '&'
        } else {
            options.url += '?'
        }
        // eslint-disable-next-line no-undef
        options.url += $.param(options.params);
    }
    if (!options.contentType) {
        options.contentType = 'application/json';
    }
    let dataType = '';
    if (options.contentType == 'application/json') {
        dataType = 'json'
    }
    let xhrFields = {};
    if (options.withCredentials) {
        xhrFields.withCredentials = true;
    }
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        $.ajax({
            url: options.url,
            contentType: options.contentType,
            method: options.method,
            dataType: dataType,
            data: JSON.stringify(options.data),
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            },
            xhrFields
        }).done((resp, textStatus, jqXHR) => {
            if (options.returnDetailed === true) {
                let headers = {};
                let headerTexts = jqXHR.getAllResponseHeaders().split("\r\n");
                headerTexts.forEach(function (header) {
                    header = header.split(": ");
                    var key = header.shift();
                    if (key.length == 0) return
                    // chrome60+ force lowercase, other browsers can be different
                    key = key.toLowerCase();
                    headers[key] = header.join(": ");
                });
                resolve({ response: resp, headers })
            } else {
                resolve(resp);
            }
        }).fail(resp => {
            reject(resp);
        });
    });
}

export function uploadFile(file) {
    return new Promise((resolve, reject) => {
        let url = sharedGlobal.appUrls.insSharedApiUrl + 'api/InsShared/UploadDocument?fileName=' + encodeURIComponent(file.name);
        let formData = new FormData();
        formData.append("file", file);
        // eslint-disable-next-line no-undef
        $.ajax({
            url: url,
            contentType: false,
            processData: false,
            data: formData,
            type: 'POST',
            crossDomain: true,
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            }

        }).then(function (sr, status, xhr) {
            resolve(sr);
        }).fail(resp => {
            reject(resp);
        })
    })
} 